module.exports = __webpack_public_path__ + "img/Apoptosis-BRCA_10X_IDC.07f61af5.png";